// src/lib/materialCategories.js
// ───────────────────────────────────────────────────────────────────────────
// Categorías de material — fuente única para MaterialModal, filtros y retales.
// PLAN-INVENTARIO-RETALES §2: se añaden Falconboard / Corplast / Honeycomb /
// Re-board. Deuda señalada (§3.4): migrar a config-en-datos (Firestore) después;
// centralizarlas aquí es el paso intermedio para que ese refactor toque UN lugar.
// ───────────────────────────────────────────────────────────────────────────

/** Categorías disponibles (los strings existentes se preservan tal cual en datos). */
export const MATERIAL_CATEGORIES = [
    'Carton',
    'Falconboard',
    'Corplast',
    'Honeycomb',
    'Re-board',
    'Metal',
    'PVC',
    'Acrilico',
    'Foam',
    'Vinyl',
    'Banner',
    'Plywood',
    'Otro',
];

/**
 * ¿La categoría es cartón corrugado? → aplica la REGLA de flauta (§5b):
 * la 1ª medida (m1) es SIEMPRE la dirección de flauta.
 */
export function isCorrugated(category) {
    return String(category || '').trim().toLowerCase() === 'carton';
}

/**
 * Línea de specs de la plancha para mostrar DENTRO de los modales (no solo en la
 * tarjeta): "85.12×110 in · 3 mm". PURO. '' si el material no tiene medidas.
 */
export function materialSpecLine(m) {
    if (!m) return '';
    const dims = (m.dimensions?.width && m.dimensions?.height)
        ? `${m.dimensions.width}×${m.dimensions.height} ${m.dimensions.unit || ''}`.trim() : '';
    const th = m.thickness?.value ? `${m.thickness.value} ${m.thickness.unit || 'mm'}` : '';
    return [dims, th].filter(Boolean).join(' · ');
}
